import request from '../../utils/request';

function getSessions({
  search = '',
  clientId = null,
  announcementId = null,
  page = 1,
  pageSize = 25,
} = {}) {
  const params = {};

  if (search) {
    params.search = search;
  }

  if (clientId !== null && clientId !== undefined) {
    params.clientId = clientId;
  }

  if (announcementId !== null && announcementId !== undefined) {
    params.announcementId = announcementId;
  }

  params.page = page;
  params.pageSize = pageSize;

  return request({
    url: 'session/list',
    method: 'GET',
    private: true,
    params,
    
  });
}
function cancelSession(idSession, reason) {
  return request({
    url: `sessions/${idSession}/cancel`,
    method: 'PATCH',
    data: reason,
    private: true,
  });
}
function getDetailsSession(id) {
  return request({
    url: `/sessions/${id}/admin`,
    method: 'GET',
    private: true,
  });
}
function getAutomationSummary(
  id,
  { page = 1, limit = 8, userId = '', source = '', from = '', to = '' } = {}
) {
  const params = {
    sessionId: id,
    page,
    limit,
  };

  if (userId) {
    params.userId = userId;
  }
  if (source) {
    params.source = source;
  }
  if (from) {
    params.from = from;
  }
  if (to) {
    params.to = to;
  }

  return request({
    url: '/mentorship-activity-logs',
    method: 'GET',
    private: true,
    params,
  });
}
function getFileDownload(id) {
  return request({
    url: `/file/download/${id}/admin`,
    method: 'GET',
    private: true,
  });
}
function getMentors() {
  return request({
    url: '/users/schedules',
    method: 'GET',
    private: true,
  });
}
function assignMentor(id, payload) {
  return request({
    url: `/session/${id}/assign`,
    method: 'POST',
    data: payload,
    private: true,
  });
}
function getDatesByMentor(idMentor) {
  return request({
    url: `/schedules/users/${idMentor}`,
    method: 'GET',
    private: true,
  });
}
function assignDate(id, idSchedule) {
  return request({
    url: `/session/${id}/schedule/${idSchedule}`,
    method: 'PATCH',
    data: {},
    private: true,
  });
}

function getParticipantsBySession(id) {
  return request({
    url: `/session/${id}/participants`,
    method: 'GET',
    private: true,
  });
}

function getAnnouncementMeetingsReport(id) {
  return request({
    url: `session/announcement/${id}/report`,
    method: 'GET',
    private: true,
    responseType: 'blob',
  });
}

function updateSessionStatus(id, status) {
  return request({
    url: `/session/${id}/status/${status}`,
    method: 'PATCH',
    private: true,
  });
}

const SessionAPI = {
  getSessions,
  cancelSession,
  getDetailsSession,
  getAutomationSummary,
  getFileDownload,
  getMentors,
  assignMentor,
  getDatesByMentor,
  assignDate,
  getParticipantsBySession,
  getAnnouncementMeetingsReport,
  updateSessionStatus,
};

export default SessionAPI;
